export default __webpack_public_path__ + "static/media/pic25.33f06026.jpg";